export default __webpack_public_path__ + "static/media/top3.dc41be40.svg";